// import state from './state'
// import * as getters from './getters'
// import * as mutations from './mutations'
import * as actions from './actions'
import config from '@/v2/config'

// initial state
const state = {
  inspection: {
    id: '',
    ts_id: '',
    status_code: '',
    inspection_estimate_id: '',
    tel: '',
    user_request: '',
    replacement_vehicle_requested: '',
    memo: '',
    payment_memo: '',
    mechanic_name: '',
    pos_cost: '',
    maintenance_time: '',
    canceled_at: '',
    canceled_code: '',
    expected_inspection_at: '',
    expected_return_at: '',
    maintenance_start_at: '',
    maintenance_completed_at: '',
    payment_completed_at: '',
    returned_at: '',
    payment_method_code: '',
    estimate_price: '',
    before_maintenance_price: '',
    payment_price: '',
    application_category: config.APPLICATION_CATEGORY_APP
  },
  detail: [{
    id: '',
    ts_id: '',
    status_code: '',
    inspection_estimate_id: '',
    tel: '',
    user_request: '',
    replacement_vehicle_requested: '',
    memo: '',
    payment_memo: '',
    mechanic_name: '',
    pos_cost: '',
    maintenance_time: '',
    canceled_at: '',
    canceled_code: '',
    expected_inspection_at: '',
    expected_return_at: '',
    expected_inspection_fixed_at: '',
    maintenance_start_at: '',
    maintenance_completed_at: '',
    payment_completed_at: '',
    returned_at: '',
    payment_method_code: '',
    estimate_price: '',
    before_maintenance_price: '',
    payment_price: '',
    application_category: config.APPLICATION_CATEGORY_APP,
    inspection_estimate: {
      id: '',
      ts_id: '',
      popinfo_id: '',
      prefecture_id: '',
      coupon_id: '',
      cars_id: '',
      ss_code: '',
      ss_factory_type_code: '',
      mileage: '',
      weight: '',
      model_code: '',
      plate_number: '',
      first_registration_on: '',
      manufacturer_id: '',
      expiry_on: '',
      oil_exchanged: ''
    },
    inspection_price: {
      id: '',
      status_code: '',
      inspection_id: '',
      cali_fee: '',
      weight_tax: '',
      revenue_stamp_fee: '',
      base_price: '',
      oil_exchanged_fee: '',
      coupon_fee: ''
    },
    inspection_additional_expense: {
      id: '',
      inspection_id: '',
      status_code: '',
      contents: '',
      price: ''
    }
  }]
}

// getters
const getters = {
  inspection: (state, getters) => {
    return state.inspection
  },
  detail: (state, getters) => {
    return state.detail
  }
}

// mutations
const mutations = {
  SET_INSPECTION (state, data) {
    state.inspection = data
  },
  SET_DETAIL (state, data) {
    state.detail = data
  }
}

// actions
// const actions = {
//   async setEstimate (context) {
//     const result = await estimate.get()
//     context.commit('SET_ESTIMATE', result.data)
//   }
// }

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
